import roundToFixed from '@/utils/roundToFixed'

export default function(priceInCents) {
  let abs = Math.abs(priceInCents)
  let prefix = priceInCents >= 0 ? '$' : '-$'
  let string = `${prefix}${roundToFixed(abs / 100)}`
  return string
}
